import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FileCaptureService } from 'app/service/file-capture.service';
import { FileSizePipe } from '../pipes/file-size.pipe';
import { FileServiceService } from '../service/file-service.service';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { NotificationService } from 'app/service/notification-service';

@Component({
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {
    isFirst: any = true;
    files: any = [];
    showError: boolean = false;
    errorMsg: string = '';
    acceptedFiles: string = '.doc, .docx, .dcm, .pdf, .xls, .xlsx, .jpeg, .jpg, .bmp, .png, .tif, .tiff, .wav, .mp3, .txt, .text/plain, .mkv, .eml';
    FilesToUpload: any = [];
    canUpload: boolean = true;
    isViewOnly: boolean = false;
    isLoading: boolean = false;
    BufferChunkSize: any;
    hasUpdate: boolean;
    isDisabled: boolean = true;
    notification: NotificationService;
    fileUploadMap: any = {};
    queue: any = [];
    totalUploadedFiles: any = 0;
    constructor(
        private route: Router, 
        private fcservice: FileCaptureService, 
        public service: FileServiceService, 
        private filesize: FileSizePipe, 
        private http: HttpClient,
        public notificationService: NotificationService
    ) {
    }

    ngOnInit(): void {
        this.notification = this.notificationService;

        const refData = this.service.getCache('contactEmail');
        if (refData) {
            this.service.setPageVisited('reference');
        }

        this.service.setPageVisited('file-upload');

        const cachedFiles = this.service.getCache('files');
        const attachmentSaved = this.service.getCache('attachmentSaved');

        if (cachedFiles && cachedFiles.length > 0) {
            this.files = [...cachedFiles];
            this.FilesToUpload = [...cachedFiles];
            this.service.referenceFileDetails.files = [...cachedFiles];
            this.isDisabled = this.files.length === 0;
            this.totalUploadedFiles = this.files.length;
        } else {
            this.files = [];
            this.FilesToUpload = [];
            this.isDisabled = true;
        }
    }

    next() {
    this.service.referenceFileDetails.files = [...this.FilesToUpload];
    this.service.setCacheForitems([{ id: 'files', value: [...this.FilesToUpload] }]);
    this.route.navigate(['review-files']);
    }

    @HostListener('window:dragover', ['$event'])
    allowDrag(e) {

        e.dataTransfer.dropEffect = 'copy';
    }

    @HostListener('window:drop', ['$event'])
    handleDrop(e) {
        this.uploadFiles(e.dataTransfer.files);
    }
    onFileChange(event: any) {
        const pFileList = event.files ? event.files : event;
        if (pFileList.length > 500) {
            this.showError = true;
            this.errorMsg = "Maximum of 500 files can be uploaded";
            return;
        }
        for (let index = 0; index < pFileList.length; index++) {
            const element = pFileList[index];
            const [size, unit] = this.filesize.transform(element.size).split(' ');
            if (parseFloat(size) > 1.5 && unit === 'GB') {
                this.showError = true;
                this.errorMsg = "Files size should be less than 1.5 GB" + ', ' + element.name;
                return;
            } else {
                this.showError = false;
            }
        }
        this.isDisabled = true;
        this.uploadFiles(event);
    }


    uploadFiles(event: any) {
    const files = event.files ? event.files : event;
    const existingFiles = this.service.getCache('files') || [];

    if (!this.FilesToUpload || this.FilesToUpload.length === 0) {
        this.FilesToUpload = [...existingFiles];
    }

    let duplicateFileExist = false;
    const incomingFiles = Array.from(files);

    duplicateFileExist = incomingFiles.some((incoming: any) =>
        this.FilesToUpload.some((existing: any) => (existing.fileName ?? existing.name) === incoming.name)
    );

    if (files.length > 0 && !duplicateFileExist) {
        for (let i = 0; i < incomingFiles.length; i++) {
        const currentFile: any = incomingFiles[i];

        const attachment = {
            fileName: currentFile.name,
            fileType: currentFile.name.substring(currentFile.name.lastIndexOf('.') + 1),
            percentage: 0,
            fileSize: currentFile.size || 0,
            sizeReadable: this.humanFileSize(currentFile.size || 0, true),
            isFirst: !this.service.getCache('attachmentSaved'),
            fileId: this.FilesToUpload.length,
            activityName: 'Deconfliction',
            attachmentLength: currentFile.size,
            targetFile: currentFile,
            referenceId: this.service.getCache('referenceId'),
            isUpload: 1
        };

        this.FilesToUpload.push(attachment);
        this.fcservice.fileArray.push(currentFile);
        }

        this.files = [...this.FilesToUpload];
        this.service.setCacheForitems([{ id: 'files', value: [...this.FilesToUpload] }]);
        this.isDisabled = this.files.length === 0;
    }
    }

    humanFileSize(bytes: any, si: any) {
        var thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }

    checkFileType(fileType) {
        switch (fileType.toLowerCase()) {
            case "doc":
                return true;
            case "docx":
                return true;
            case "pdf":
                return true;
            case "xls":
                return true;
            case "xlsx":
                return true;
            case "jpeg":
                return true;
            case "jpg":
                return true;
            case "bmp":
                return true;
            case "png":
                return true;
            case "tif":
                return true;
            case "tiff":
                return true;
            case "wav":
                return true;
            case "mp3":
                return true;
            case "txt":
                return true;
            case "text/plain":
                return true;
            case "htm":
                return true;
            case "html":
                return true;
            case "csv":
                return true;
            case "ppt":
                return true;
            case "pptx":
                return true;
            case "eml":
                return true;
            default:
                return false;
        }
    }

    back() {
        this.route.navigate(['reference']);
    }

    cancel() {
        const sessionId = window.sessionStorage.getItem(this.fcservice.SESSION_KEY) || '';
        const payorKey = Number(window.sessionStorage.getItem(this.fcservice.PAYOR_KEY) || 0);
        const referenceId = this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId');

        if (sessionId && payorKey > 0 && referenceId) {
            this.fcservice.releaseReferenceLock(referenceId, payorKey, sessionId).subscribe();
            window.sessionStorage.removeItem(this.fcservice.SESSION_KEY);
        }

        this.service.referenceFileDetails.referenceId = "";
        this.service.clearCache();
        let url = window.localStorage.getItem('securityCode');
        this.route.navigate(['/' + url]);
    }

    onUpload(files: any): void {
        var i = 0;
        for (const file of files) {
            const formData = new FormData();
            var jsonData = JSON.stringify({
                referenceid: this.service.getCache('referenceId'),
                activityName: 'Deconfliction',
                isFirst: i == 0
            });

            formData.append('jsonData', jsonData);
            formData.append('files', file, file.name);
            i++;
            this.fcservice.addFilesToDB(formData).subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    console.log('Upload Progress: ' + Math.round(100 * event.loaded / event.total) + '%');
                } else if (event.type === HttpEventType.Response) {
                    console.log('Upload complete');
                }
            });
        }

    }
    closeNotification(index: number) {
        this.notification.queue.splice(index, 1);
    }

    removeFile(index: number) {
        this.files.splice(index, 1);
        this.FilesToUpload.splice(index, 1);
        this.service.setCacheForitems([{ id: "files", value: this.FilesToUpload }]);
        if (this.FilesToUpload.length == 0) {
            this.isDisabled = true;
        }
    }
}
